const reactSelectOptionsFromEnum = (enumObj) => {
  if (!enumObj) {
    return [];
  }

  const data = Object.entries(enumObj);

  if (!data || (data && Array.isArray(data) && data.length === 0)) {
    return [];
  }

  return Object.entries(enumObj).map(([key, value]) => {
    return {
      label: value,
      value: key
    };
  });
};

export default reactSelectOptionsFromEnum;
